import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type PostCreateMutationVariables = Types.Exact<{
  input: Types.PostCreateInput;
}>;

export type PostCreateMutation = { __typename?: 'Mutation'; postCreate?: { __typename?: 'Post'; id: string } | null };

export type PostUpdateMutationVariables = Types.Exact<{
  input: Types.PostUpdateInput;
}>;

export type PostUpdateMutation = {
  __typename?: 'Mutation';
  postUpdate?: {
    __typename?: 'Post';
    id: string;
    slug?: string | null;
    status: Types.SharryContentStatus;
    createdAt?: any | null;
    publishedAt?: any | null;
    contentType?: string | null;
    editable?: boolean | null;
    title?: string | null;
    originalTitle?: string | null;
    originalDescription?: string | null;
    description?: string | null;
    shortAddress?: string | null;
    address?: string | null;
    searchableAddress?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    province?: string | null;
    municipality?: string | null;
    shortProvince?: string | null;
    region?: string | null;
    sharryContentsIds?: Array<string> | null;
    taggedUsersIds?: Array<string> | null;
    sharrySelection?: Types.SharrySelection | null;
    website?: string | null;
    originalLanguage?: string | null;
    landIds?: Array<string> | null;
    coverPicture?: {
      __typename?: 'GalleryImage';
      id?: string | null;
      bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null; thumbnail?: string | null } | null;
    } | null;
    galleryContents?: Array<
      | {
          __typename?: 'GalleryEmbed';
          id?: string | null;
          author?: string | null;
          copyrightLink?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'GalleryImage';
          id?: string | null;
          author?: string | null;
          copyrightLink?: string | null;
          description?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }
    > | null;
    communityTags?: Array<{ __typename?: 'Hashtag'; id: string; name: string }> | null;
    owner?: {
      __typename?: 'User';
      id: string;
      slug?: string | null;
      isProGold?: boolean | null;
      role: Types.UserRole;
      sharrylandPartner: boolean;
      anonymised?: boolean | null;
      isVisible?: boolean | null;
      isMe: boolean;
      name?: string | null;
      surname?: string | null;
      businessName?: string | null;
      isSmallOrganisation?: boolean | null;
      qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
      image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
    reviews?: Array<{
      __typename?: 'SharryReview';
      id: string;
      parent?: { __typename?: 'SharryReview'; id: string } | null;
    }> | null;
    contentLikes?: Array<{
      __typename?: 'ContentLike';
      id: string;
      user: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        surname?: string | null;
        isSmallOrganisation?: boolean | null;
        anonymised?: boolean | null;
        businessName?: string | null;
        isMe: boolean;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
      };
    }> | null;
    sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
  } | null;
};

export type PostDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type PostDeleteMutation = { __typename?: 'Mutation'; postDelete?: { __typename?: 'Post'; id: string } | null };

export type TranslationRequestMutationVariables = Types.Exact<{
  input: Types.TranslationRequestInput;
}>;

export type TranslationRequestMutation = {
  __typename?: 'Mutation';
  translationRequest?: { __typename?: 'OperationReturn'; success?: Types.OperationReturnTypeEnum | null } | null;
};

export type LandContentMutationMutationVariables = Types.Exact<{
  input: Types.LandContentMutationInput;
}>;

export type LandContentMutationMutation = {
  __typename?: 'Mutation';
  landContentMutation?: { __typename?: 'OperationReturn'; success?: Types.OperationReturnTypeEnum | null } | null;
};

export const PostCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'postCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PostCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class PostCreateGQL extends Apollo.Mutation<PostCreateMutation, PostCreateMutationVariables> {
  document = PostCreateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const PostUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'postUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PostUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Post' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Post' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Post' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'editable' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GalleryImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '80x80', block: false },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'thumbnail' },
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'convert' },
                                  value: { kind: 'BooleanValue', value: false },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '500x500', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'author' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'copyrightLink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GalleryImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '600x600', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originalTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'originalDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'searchableAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortProvince' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentsIds' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taggedUsersIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'communityTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymised' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isVisible' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualification' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMe' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLikes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMe' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'website' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'originalLanguage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landIds' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class PostUpdateGQL extends Apollo.Mutation<PostUpdateMutation, PostUpdateMutationVariables> {
  document = PostUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const PostDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'postDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class PostDeleteGQL extends Apollo.Mutation<PostDeleteMutation, PostDeleteMutationVariables> {
  document = PostDeleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const TranslationRequestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'translationRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TranslationRequestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'translationRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class TranslationRequestGQL extends Apollo.Mutation<
  TranslationRequestMutation,
  TranslationRequestMutationVariables
> {
  document = TranslationRequestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const LandContentMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'landContentMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LandContentMutationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landContentMutation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class LandContentMutationGQL extends Apollo.Mutation<
  LandContentMutationMutation,
  LandContentMutationMutationVariables
> {
  document = LandContentMutationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
